export const BASE_URL_ADMIN = "https://api.bee-net.co.uk/api/admin";
export const BASE_URL_USER = "https://api.bee-net.co.uk/api/user";
